import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar/Sidebar';
import Contact from './pages/Contact/Contact';
import HomepageForm from './pages/Homepage/Hompage';
import Exam from './pages/Exam/Exam';
import ExamCalendar from './components/ExamCalender/ExamCalendar';
import ExamResults from './components/ExamResult/ExamResult';
import QuestionPaper from './components/QuestionPaper/QuestionPaper';
// import UpcomingExams from './components/UpcomingExam';
import ChairmanMessage from './pages/ChairmanMessage/ChairmanMessage';
import FAQComponent from './pages/Faq/Faq';
import SuccessStories from './pages/SuccessStories/Stories';
import UpcomingBatches from './pages/UpcomingBatches/UpcomingBatches';
import LoginPage from './pages/Login/login';
import Users from './pages/Users/Users';
import Methodology from './pages/Methodology/Methodology';
import './App.css';  // Keep your custom CSS
import { jwtDecode } from 'jwt-decode';
import Courses from './pages/Courses/Courses';
import Portfolio from './pages/Portfolio/Portfolio';
import PopupsManager from './pages/PopUps/popups';
import MaterialManager from './pages/Material/Material';
import CentersLocation from './pages/CentersLocation/CentersLocation';
import ManageCentres from './pages/ExamCentres/ManageCentres';
import HallTicketForm from './pages/hallTicket';
import ManageSubscriptionPriceDetails from './pages/SubsriptionDetails/ManageSubscriptionPrice';
import ExamManager from './pages/CodeFormat/CodeFormat';
import ManageMissionAndVision from './pages/missionAndVision/missionAndVision';
import NotificationsManager from './pages/NotificationCentre/manageNotification';
import HallTickets from './pages/Halltickets/Halltickets';
import Orders from './pages/Orders/ManageOrder';
import Shipments from './pages/Shipments/Shipments';
import BlogList from './pages/BlogList/BlogList';
import CreateBlog from './pages/CreateBlog/CreateBlog';
import EditBlog from './pages/EditBlog/EditBlog';
import CategoryManagement from './pages/CategoryManagement/CategoryManagement';
import  ManageZones from './pages/zones/manageZones';

function MainContent({ isAuthenticated, handleLogin, handleLogout, isLoading }) {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login'; // Check if the current route is the login page

  // Prevent rendering the routes until token is checked
  if (isLoading) {
    return <div>Loading...</div>; // Show a loading indicator until the token is checked
  }

  return (
    <div className="admin-main-app">
      {!isLoginPage && isAuthenticated && <Sidebar onLogout={handleLogout} />}

      <div className={`admin-main-app-content ${isLoginPage ? 'admin-main-app-content-login' : 'admin-main-app-content-default'}`}>
        <Routes>
          <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
          {isAuthenticated ? (
            <>
              <Route path="/" element={<HomepageForm />} />
              <Route path="/user" element={<Users />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/exams" element={<Exam />} />
              <Route path="/chairmanmessage" element={<ChairmanMessage />} />
              <Route path="/faq" element={<FAQComponent />} />
              <Route path="/success-stories" element={<SuccessStories />} />
              <Route path="/batches" element={<UpcomingBatches />} />
              <Route path="/methodology" element={<Methodology />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/popups" element={<PopupsManager />} />
              <Route path="/calender" element={<ExamCalendar />} />
              <Route path="/pqns" element={<QuestionPaper />} />
              <Route path="/results" element={<ExamResults />} />
              <Route path="/materials" element={<MaterialManager />} />
              <Route path="/centers" element={<CentersLocation />} />
              <Route path="/exam-centres" element={<ManageCentres/>} />
              <Route path="/subscriptionPrice" element={<ManageSubscriptionPriceDetails/>} />
              <Route path="/codeformat" element={<ExamManager/>} />
              <Route path="/missionAndVision" element={<ManageMissionAndVision/>} />
              <Route path="/notificationCentre" element={<NotificationsManager/>} />
              <Route path="/halltickets" element={<HallTickets/>} />
              <Route path="/Orders" element={<Orders/>} />
              <Route path="/shipments" element={<Shipments/>} />
              <Route path="/create-blog" element={<CreateBlog />} />
              <Route path="/blog-list" element={<BlogList/>} />
              <Route path="/edit-blog/:id" element={<EditBlog />} />
              <Route path="/categories" element={<CategoryManagement />} />
              <Route path="zones" element={<ManageZones />} />
            </>
          ) : (
            <Route path="*" element={<Navigate to="/login" />} />
          )}
        </Routes>
      </div>
    </div>
  );
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Track loading state

  const isTokenExpired = (token) => {
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Convert to seconds
      return decodedToken.exp < currentTime; // Token is expired if current time is greater than expiration time
    } catch (error) {
      return true; // If there's an error decoding, assume the token is invalid/expired
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      if (isTokenExpired(token)) {
        alert('Your session has expired. Please log in again.');
        localStorage.removeItem('authToken');  // Clear expired token
        setIsAuthenticated(false);  // Set authentication to false
      } else {
        setIsAuthenticated(true);  // Token is valid
      }
    }
    setIsLoading(false); // Mark loading as complete
  }, []);

  const handleLogin = (token) => {
    localStorage.setItem('authToken', token);  // Store the token in localStorage
    setIsAuthenticated(true);  // Set authentication to true
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');  // Remove token on logout
    setIsAuthenticated(false);  // Set authentication to false
  };

  return (
    <Router>
      <MainContent
        isAuthenticated={isAuthenticated}
        handleLogin={handleLogin}
        handleLogout={handleLogout}
        isLoading={isLoading} // Pass loading state to MainContent
      />
    </Router>
  );
}

export default App;
